










































































































































































































































































import { BusinessUnit } from "@/shared/models/businessUnit";
import { Component, Prop, Ref, Vue, Watch } from "vue-property-decorator";
import { SortableTableHeader } from "@/components/generic-pms-table/SortableTableDirective";
import SortableHeadersTable from "@/components/generic-pms-table/SortableHeadersTable.vue";
import SortableTable from "@/components/generic-pms-table/SortableTableDirective";
import GenericPMSTableMenu from "@/components/generic-pms-table/GenericPMSTableMenu.vue";
import MessageForm from "@/components/messages/MessageForm.vue";
import { ListModel } from "@/shared/models/listModel";
import { DataOptions } from "vuetify";
import { formatOrderbyArray } from "@/shared/sortHelperFunctions";
import NoData from "@/components/misc/NoData.vue";
import { MessageViewModel, MessageSourceTypeEnum, BaseMessageTypeEnum } from "./types";
import { Notification } from "../../store/modules/notifications";
import DateField from "@/components/misc/DateField.vue";
import ConversationPanel from "./ConversationPanel.vue";
import ConversationPanelWhatsApp from "./ConversationPanelWhatsApp.vue";
import { enumToArray } from "@/shared/commonFunctions";
import * as _ from "lodash";
import { Getter } from "vuex-class";
import { formatDateTimeAccordingToTimeZoneOrUTC } from '@/shared/dateFormatUtils';

@Component({
  components: {
    GenericPMSTableMenu,
    SortableHeadersTable,
    DateField,
    ConversationPanel,
    ConversationPanelWhatsApp,
    NoData,
    MessageForm,
  },
  directives: {
    SortableTable,
  },
})
export default class MessagesTable extends Vue {
  settingsOpen = false;

  @Prop({ default: 0 }) direction?: number; // default direction is 'All'
  @Prop({ default: null }) customerId?: number | null;
  @Prop({ default: null }) reservationId?: number | null;
  @Prop() tableName?: string;

  get name() {
    return this.tableName ?? "messages";
  }

  @Getter("appParams/tenantAutoEmailsFrom") tenantAutoEmailsFrom?: string;

  @Getter("businessUnit/activeBusinessUnit") activeBusinessUnit?: BusinessUnit;

  @Getter("language/language") language?: string;

  @Ref("conversationPanel") conversationPanel?: ConversationPanel;
  @Ref("conversationPanelWhatsApp") conversationPanelWhatsApp?: ConversationPanelWhatsApp;
  
  enumToArray = enumToArray;

  messageSourceTypeEnum = MessageSourceTypeEnum;

  headers: SortableTableHeader[] = [
    {
      text: "Message.Date",
      value: "date",
      active: true,
      default: false,
      class: "resize-header",
      exportHeaders: [],
    },
    {
      text: "Message.Participants",
      value: "from",
      active: true,
      default: false,
      class: "resize-header",
      exportHeaders: [],
    },
    {
      text: "Message.Subject",
      value: "subject",
      active: true,
      default: false,
      class: "resize-header",
      exportHeaders: [],
    },
    {
      text: "Message.Customer",
      value: "customer",
      active: !this.customerId,
      default: false,
      class: "resize-header",
      exportHeaders: [],
    },
    {
      text: "Message.Reservation",
      value: "reservationId",
      active: !this.reservationId,
      default: false,
      class: "resize-header",
      exportHeaders: [],
    },
    {
      text: !this.customerId ? "Message.SourceType" : "Message.SourceType.Short",
      value: "sourceTypeId",
      active: true,
      default: false,
      class: "resize-header",
      exportHeaders: [],
    },
    {
      text: "Actions",
      value: "actions",
      sortable: false,
      active: true,
      default: true,
      class: "resize-header",
      exportHeaders: [],
      align: "center",
    },
  ];

  get translatedActiveHeaders() {
    return this.headers
      .filter((x) => x.active)
      .map((x) => ({ ...x, text: this.$t(x.text) }));
  }

  filters = {
    date: "",
    participants: "",
    subject: "",
    customer: "",
    sourceTypeId: null as number | null,
    reservationId: null as number | null,
  };

  get computedFilters() {
    return {
      ...this.filters,
      direction: this.direction,
    };
  }

  @Watch("computedFilters", { deep: true })
  watchFilters(val: any, old: any) {
    if (!_.isEqual(val, old)) {
      this.options.page = 1;
      this.debouncedLoad();
    }
  }

  options: DataOptions = {
    page: 1,
    itemsPerPage: 15,
    sortBy: ["date"],
    sortDesc: [true],
    groupBy: [],
    groupDesc: [],
    multiSort: false,
    mustSort: true,
  };

  initLoaded = false;
  @Watch("options", { deep: true })
  watchOptions(fresh: DataOptions, old: DataOptions) {
    if (!this.initLoaded || !_.isEqual(fresh, old)) {
      this.initLoaded = true;
      this.load();
    }
  }

  loading = true;
  list: ListModel<MessageViewModel> = {
    count: 0,
    result: [],
  };

  debouncedLoad = _.debounce(this.load, 500);

  async load(): Promise<ListModel<MessageViewModel>> {
    this.loading = true;
    return this.axios
      .get<ListModel<MessageViewModel>>("/messages", {
        params: this.queryParams,
      })
      .then((res) => {
        this.list = res.data;
        return this.list;
      })
      .finally(() => (this.loading = false));
  }

  get queryParams() {
    return {
      $skip: this.options.itemsPerPage * (this.options.page - 1),
      $top: this.options.itemsPerPage,
      $orderby: formatOrderbyArray(
        this.options.sortBy,
        this.options.sortDesc.map((x) => !x)
      ),
      $count: true,
      ...this.computedFilters,
      ...this.routeQueryParams,
    };
  }

  get routeQueryParams() {
    const toReturn = {
      ...this.$route.query,
    } as any;

    if (this.customerId) {
      toReturn.customerId = this.customerId;
    }
    if (this.reservationId) {
      toReturn.reservationId = this.reservationId;
    }

    return toReturn;
  }

  getRowClass(item: MessageViewModel) {
    let classes = "";
    if (!item.isRead) {
      classes = "unread";
    }

    if (item.isResolved) {
      classes += " resolved";
    }

    return classes;
  }

  getParticipants(item: MessageViewModel) {
    const participantAddresses = item.messageRecipients.filter((x) => !x.isBcc).map((x) => x.to)
    
    if (item.from) {
      if(item.from === this.tenantAutoEmailsFrom) {
        participantAddresses.push(item.from);
      }
      else {
        participantAddresses.unshift(item.from);
      }
    }

    return _.uniq(participantAddresses).join("; ");
  }

  formatTimezoneFromUtcToLocal(date: Date){
    const unformatedTimeZone = this.activeBusinessUnit?.timeZoneId;
    const timeZone = unformatedTimeZone ? unformatedTimeZone.substring(0, unformatedTimeZone.indexOf(",")) : undefined;
  
    return formatDateTimeAccordingToTimeZoneOrUTC(date, this.language ?? "", timeZone);
  }

  getSubject(item: MessageViewModel) {
    if (item.subject) {
      return item.subject;
    }
    let bodyReplacement = item.body.replaceAll(RegExp(/<[a-zA-Z/].*?>/gm), " ");
    if (bodyReplacement.length > 100) {
      bodyReplacement = bodyReplacement.substring(0, 100) + "...";
    }
    return bodyReplacement;
  }

  conversationPanelOpen = false;
  conversationPanelWhatsAppOpen = false;
  conversationPanelMessageId = null as null | number;
  conversationPanelPhoneNumber = null as null | string;
  conversationPanelCustomerName = null as null | string;
  conversationPanelCustomerId = null as null | number;
  rowDoubleClick(e: MouseEvent, { item }: { item: MessageViewModel }) {
    this.openConversation(item);
  }

  openWhatsAppConversation(customerId: number | null, customerName: string | null, phoneNumber: string | null) {
    if (!phoneNumber) {
      return;
    }
    
    this.conversationPanelPhoneNumber = phoneNumber;
    this.conversationPanelCustomerName = customerName;
    this.conversationPanelCustomerId = customerId;
    this.conversationPanelWhatsAppOpen = true;
  }

  openConversation(item: MessageViewModel) {
    if (!item.isRead) {
      this.markAsRead(item.id, true);
    }

    this.conversationPanelMessageId = item.id;
    
    if (item.sourceTypeId === this.messageSourceTypeEnum.WhatsApp) {
      
      let phoneNumber = item.messageRecipients[0]?.to;

      if (!phoneNumber) {
        phoneNumber = item.from;
      }

      this.conversationPanelPhoneNumber = phoneNumber;
      this.conversationPanelCustomerName = item.customer;
      this.conversationPanelCustomerId = item.customerId ?? null;
      this.conversationPanelWhatsAppOpen = true;
    } else {
      this.conversationPanelOpen = true;
    }
  }

  markAsRead(id: number, suppressNotification: boolean) {
    this.loading = true;
    Vue.axios
    .put("messages/" + id + "/SetMessageAsRead")
    .then(() => {
      this.settingsOpen = false;

      if (!suppressNotification) {
        this.$store.dispatch("showNotification", {
          color: "success",
          message: "Message.MarkedAsReadSuccess",
          timeout: 5000,
          localize: true,
        } as Notification);
      }
 
      this.load();
      if(this.conversationPanel && this.conversationPanelOpen) {
        this.conversationPanel.load();
      }
    }) 
    .finally(() => {
      this.loading = false
    })
  }

  markAsResolved(id: number) {
    this.loading = true;
    Vue.axios
    .put("messages/" + id + "/SetMessageAsResolved")
    .then(() => {
      this.settingsOpen = false;
      this.$store.dispatch("showNotification", {
        color: "success",
        message: "Message.MarkedAsResolvedSuccess",
        timeout: 5000,
        localize: true,
      }as Notification);

      this.load();
      if(this.conversationPanel && this.conversationPanelOpen) {
        this.conversationPanel.load();
      }
    }) 
    .finally(() => {
      this.loading = false
    })
  }

  reOpenConversationPanel = false;
  newMessageFormOpen = false;
  newMessageBase: MessageViewModel | null = null;
  newMessageType = BaseMessageTypeEnum.Reply;

  reply(item: MessageViewModel) {
    this.openNewMessagesForm(item, BaseMessageTypeEnum.Reply);
  }

  replyToAll(item: MessageViewModel) {
    this.openNewMessagesForm(item, BaseMessageTypeEnum.ReplyToAll);
  }

  forward(item: MessageViewModel) {
    this.openNewMessagesForm(item, BaseMessageTypeEnum.Forward);
  }

  openNewMessagesForm(item: MessageViewModel, type: number) {
    this.newMessageType = type;
    this.newMessageBase = _.cloneDeep(item);
    if(type != BaseMessageTypeEnum.Forward) {
      this.newMessageBase.messageAttachments = []; 
    }
    this.newMessageFormOpen = true;
    if(this.conversationPanelOpen) {
      this.conversationPanelOpen = false;
      this.reOpenConversationPanel = true;
    }
  }

  @Watch("newMessageFormOpen")
  newMessageFormOpenChanged(fresh: boolean, old: boolean) {
    if(fresh == false && old == true && this.reOpenConversationPanel) {
      this.conversationPanelOpen = true;
      this.reOpenConversationPanel = false;
    }
  }

  deleteConfirm() {
    alert("TODO");
  }

  delete() {
    alert("TODO");
  }
}
